var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0752 6.13303C12.0752 9.33054 9.4831 11.9226 6.28558 11.9226H6.11481C2.91729 11.9226 0.325195 9.33054 0.325195 6.13303C0.325195 2.93552 2.91729 0.343422 6.11481 0.343422H6.28558C9.4831 0.343422 12.0752 2.93552 12.0752 6.13303Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78669 3.55291C4.56986 3.33608 4.21831 3.33608 4.00149 3.55291C3.78466 3.76974 3.78466 4.12129 4.00149 4.3381L5.45962 5.79627L4.0015 7.25443C3.78468 7.47119 3.78468 7.82275 4.0015 8.03959C4.21833 8.25642 4.56988 8.25642 4.78669 8.03959L6.24485 6.5815L7.70294 8.03959C7.91977 8.25642 8.27134 8.25642 8.48817 8.03959C8.70501 7.82275 8.70501 7.47119 8.48817 7.25435L7.03001 5.79627L8.48817 4.3381C8.70501 4.1213 8.70501 3.76976 8.48817 3.55293C8.27134 3.3361 7.91977 3.3361 7.70294 3.55293L6.24485 5.01103L4.78669 3.55291Z",
    fill: "#EE9595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearall);
export default __webpack_public_path__ + "static/media/Clear all.efab8750942334d6e7453ab4733b2e3f.svg";
export { ForwardRef as ReactComponent };